export default __webpack_public_path__ + "static/media/arrow_right_filled.ff473f98.svg";